"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEditorTags = void 0;

var _getProperty = require("./getProperty");

var _generateMomentTags = require("./generateMomentTags");

var _tagData = require("./tagData");

var _format = require("./format");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var getEditorTags = function getEditorTags(sport, categories) {
  var game = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var tags = [];

  if (sport === "baseball") {
    tags = _tagData.BASEBALL_TAGS;
  } else {
    tags = _tagData.SOCCER_TAGS;
  }

  var descTags = [];
  var keys = Object.keys(tags);

  var _iterator = _createForOfIteratorHelper(categories),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var cat = _step.value;

      var _iterator3 = _createForOfIteratorHelper(keys),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _tag$editor;

          var key = _step3.value;
          var tag = tags[key];

          if ((_tag$editor = tag.editor) !== null && _tag$editor !== void 0 && _tag$editor.categories) {
            if (tag.editor.categories.includes(cat)) {
              descTags.push(_objectSpread(_objectSpread({}, tag), {}, {
                category: cat,
                name: key
              }));
            }
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  if (categories.includes("Players") && game) {
    var _iterator2 = _createForOfIteratorHelper(game.home_team.players),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var player = _step2.value;
        descTags.push({
          sort: 1000 + player.trace_number,
          category: "Players",
          name: "player-".concat(player.user.user_id),
          title: (0, _format.format)(player, _format.Formats.PlayerShortName),
          editor: {
            attributes: {
              meta: {
                trace_numbers: player.trace_number
              }
            }
          }
        });
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  descTags = descTags.sort(function (a, b) {
    var _a$sort, _b$sort;

    var aSort = (_a$sort = a.sort) !== null && _a$sort !== void 0 ? _a$sort : Math.INT_MAX_VALUE;
    var bSort = (_b$sort = b.sort) !== null && _b$sort !== void 0 ? _b$sort : Math.INT_MAX_VALUE;
    return aSort - bSort;
  });
  return descTags;
};

exports.getEditorTags = getEditorTags;